import { AxiosError } from "axios";
import { ref } from "vue";

export interface Alert {
  type: "info" | "success" | "warning" | "danger",
  title?: string,
  sub?: string,
  message: string,
  id: number,
}

class AlertQueue {
  public static info(msg: string, sub?: string, title?: string): void {
    this.push("info", msg, sub, title);
  }

  public static success(msg: string, sub?: string, title?: string): void {
    this.push("success", msg, sub, title);
  }

  public static warn(msg: string, sub?: string, title?: string): void {
    this.push("warning", msg, sub, title);
  }

  public static danger(msg: string | unknown, sub?: string, title?: string): void {
    const tryData = msg as AxiosError;
    if (tryData.isAxiosError) msg = `未知错误: ${tryData.message}`;
    this.push("danger", msg as string, sub, title);
  }

  private static instance_: AlertQueue;
  private static alerts_ = ref([] as Array<Alert>);
  private constructor() {}
  private static DestroyDelay = 10000;

  public static get instance(): AlertQueue {
    return this.instance_ || (this.instance_ = new this());
  }

  private static push(type: "info" | "success" | "warning" | "danger", msg: string, sub?: string, title?: string): void {
    if (!title) {
      switch (type) {
        case "info":
          title = "消息";
          break;
        case "success":
          title = "成功";
          break;
        case "warning":
          title = "注意";
        break;
        case "danger":
          title = "警告";
          break;
        default:
          break;
      }
    }

    this.alerts_.value.push({
      type: type,
      message: msg,
      title: title,
      sub: sub,
      id: +new Date,
    });

    setTimeout(() => {
      this.alerts_.value.shift();
    }, this.DestroyDelay);
  }

  // eslint-disable-next-line
  public static get queue() {
    return this.alerts_;
  }
}

export {
  AlertQueue,
}

